import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@app/service/state/state.service';
import { RouteComponent } from '../../route.component';
import { FiUserService } from '@app/service/fi-user-service/fi-user.service';
import { HeaderService } from '@app/service/header/header.service';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Translations from './fi-authenticate.component.json';
import { FiRoute } from '@assets/val/route-constants';
import {
  Data,
  EventResult,
} from '@app/component/finshark-iframe/finshark-iframe.component';
import { FinsharkResult } from '@app/service/credit/credit.service';

@Component({
  selector: 'app-fi-authenticate',
  templateUrl: './fi-authenticate.component.html',
  styleUrls: ['../../page-shared.css', './fi-authenticate.component.scss'],
})
export class FiAuthenticateComponent extends RouteComponent implements OnInit {
  loading: boolean = true;
  isStartingIframe: boolean = false;
  error: boolean = false;
  navigationInProgress: boolean = false;

  iframeUrl: SafeResourceUrl;

  translations: { [key: string]: string };

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private fiUserService: FiUserService,
    private sanitizer: DomSanitizer
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    this.translations =
      Translations[
        this.fiUserService.getCurrentStateLocaleBaseCode(this.state.language)
      ];
    this.loading = false;
  }

  async fetchFinsharkUrl(): Promise<void> {
    this.loading = true;
    try {
      this.fiUserService.getFinsharkUrl().subscribe((resp) => {
        if (!resp.url || resp.error || resp.rejected) {
          this.error = true;
        } else if (resp.url) {
          this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            resp.url
          );
        }
      });
    } catch (err) {
      this.error = true;
      this.handleError(err);
    }

    this.loading = false;
  }

  async handleFinsharkResults(eventData: Data): Promise<void> {
    const finsharkResult: FinsharkResult = {
      authorizationId: eventData.authorizationId,
      sessionId: eventData.sessionId,
      result: eventData.result,
      verifiedAccountId: eventData.verifiedAccountId,
      ownerName: '',
    };

    if (
      !finsharkResult.authorizationId ||
      !finsharkResult.verifiedAccountId ||
      !finsharkResult.sessionId ||
      finsharkResult.result !== EventResult.SUCCESS
    ) {
      this.error = true;
      return;
    }

    try {
      await this.fiUserService
        .postFinsharkResults(finsharkResult)
        .then(() => this.navigate());
    } catch (err) {
      this.error = true;
      this.handleError(err);
    }
  }

  async handleCancellation(): Promise<void> {
    this.navigationInProgress = true;
    this.router.navigate([FiRoute.HOME], {
      queryParamsHandling: 'merge',
    });
    this.navigationInProgress = false;
  }

  async handleContinueClick(): Promise<void> {
    await this.fetchFinsharkUrl();
  }

  async onEventData(eventData: Data): Promise<void> {
    if (eventData.result === EventResult.SUCCESS) {
      await this.handleFinsharkResults(eventData);
    } else if (eventData.result === EventResult.ERROR) {
      this.error = true;
    } else if (eventData.result === EventResult.CANCELED) {
      await this.handleCancellation();
    }
  }

  getPartEightDisclaimer(): string {
    return this.translations.disclaimerPartEight.replace(
      '${MERCHANT}',
      this.state.checkoutCustomizations.merchantName
    );
  }
}
